import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { format } from "date-fns";

const Wrapper = styled.div`
  height: 70px;
  padding: 0 1em;
  background: ${({ color }) => `#${color}`};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #FFFFFF;
  align-content: center;
`;

const Title = styled.div`
  font-family: Work Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
`;

const Description = styled.div`
  font-family: Work Sans;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0em;
  text-transform: uppercase;
`;

const Header = ({ dealName, loanName, type, color, companyLogo }) => {
  const [maxLogoDimensions, setMaxLogoDimensions] = useState({ height: "64px", width: "64px" });
  const currentDate = format(new Date(), "MMMM dd, yyyy");
  const generateTitle = () => (!loanName ? `${dealName} - ${type}` : `${dealName} - ${loanName} - ${type}`);
  const logoRef = useRef();

  useEffect(() => {
    if (logoRef?.current) {
      const { height = 0, width = 0 } = logoRef?.current;
      const isRectangularShape = width >= 1.5 * height;
      isRectangularShape ? setMaxLogoDimensions({ height: "40px", width: "100px" }) : setMaxLogoDimensions({ height: "64px", width: "64px" });
    }
  }, [companyLogo]);

  return (
    <Wrapper color={color}>
      <TitleWrapper>
        <Title>{generateTitle()}</Title>
        <Description>{currentDate}</Description>
      </TitleWrapper>
      {companyLogo &&
        <img
          ref={logoRef}
          src={companyLogo}
          alt="company-logo"
          width="100%"
          style={{ maxHeight: maxLogoDimensions.height, maxWidth: maxLogoDimensions.width }}
        />}

    </Wrapper>
  );
};

export default Header;
